export default __webpack_public_path__ + "static/media/pop.15167204.wav";